import { MainLayout } from 'components/layout/MainLayout/index.js';
import type { TMenuItem } from 'components/navigation/NavMenuItem/index.js';

export const useRoutesRootElement = () => {
  const renderRootElement = (navigationItems: TMenuItem[]) => {
    return <MainLayout navigationItems={navigationItems} />;
  };

  return renderRootElement;
};
